import { useResizeDetector } from 'react-resize-detector'

export function usePatientConsultationResponsive() {
  const { ref: containerRef, width: containerWidth = 0 } = useResizeDetector<HTMLDivElement>()

  // Define responsive breakpoints based on container width
  const isExtraSmall = containerWidth < 600
  const isSmall = containerWidth >= 600 && containerWidth < 900
  const isMedium = containerWidth >= 900 && containerWidth < 1200
  const isLarge = containerWidth >= 1200

  // Determine layout based on container width
  const shouldStackMain = isExtraSmall || isSmall || isMedium
  const shouldWrapDetails = isExtraSmall || isSmall

  return {
    // Refs
    containerRef,

    // Width info
    containerWidth,

    // Breakpoint flags
    isExtraSmall,
    isSmall,
    isMedium,
    isLarge,

    // Layout decisions
    shouldStackMain,
    shouldWrapDetails,
  }
}
